export const marketSurveillanceMenuName = 'Menu::MenuG:MarketSurveillance';
export const manageMarketsInterconAllocationDashboard = 'Menu::MenuG:InterconAllocationDashboard';
export const ttcDeviationDashboard = 'Menu::MenuG:TtcDeviationDashboard';
export const ttcDeviationStats = 'Menu::MenuG:TtcDeviationStats';
